import { useState, useEffect } from 'react';
import { Box, Flex, Spinner, Divider } from "@chakra-ui/react";

import OrgInfoDisplay from '../../../organizations/components/OrgInfoDisplay';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import StripeCustomerPortalButton from '../../../payments/components/StripeCustomerPortalButton';
import DynamicAppBannerDisplay from '../../../global/components/helper-components/components/DynamicAppBannerDisplay';
import EditOrgBillingForm from './EditOrgBillingForm';


export default function OrgBillingModule({
	adminOrgProfile,
	manageAdminOrgUsersOutcome,
	isMobileView
}) {
	const [localState, setLocalState] = useState({
		orgName: "",
		orgRegisteredAddress: "",
		orgRegisteredName: "",
		orgRegisteredNumber: "",
		orgRegisteredCountry: "",
		//Upload
		uploadedLogo: "",
		orgSeats: "",
		//UX
		buttonIsLoading: false,
		noOrgFound: "",
		isAdministrator: "",
		logoImageIsLoading: true,
	})
	const [showEditOrgInfoModal, setShowEditOrgInfoModal] = useState(false);
	const [orgProfile, setOrgProfile] = useState(null)


	useEffect(() => {
		if (adminOrgProfile) {

			const {
				orgId,
				orgName,
				orgRegisteredAddress,
				orgRegisteredName,
				orgRegisteredNumber,
				orgRegisteredCountry,
				orgDescription,
				isAdministrator,
				orgSeats,
				subscriptionReminder
			} = adminOrgProfile || {};

			setOrgProfile({
				orgId,
				orgName,
				orgRegisteredCountry,
				orgRegisteredAddress,
				orgRegisteredName,
				orgRegisteredNumber,
				orgDescription
			})

			setLocalState(prevLocalState => ({
				...prevLocalState,
				isAdministrator,
				orgName,
				orgRegisteredAddress,
				orgRegisteredName,
				orgRegisteredNumber,
				orgRegisteredCountry,
				orgSeats,
				noOrgFound: false,
				subscriptionReminder
			}))
		} else {
			setLocalState(prevLocalState => ({
				...prevLocalState,
				noOrgFound: true
			}));
		}
	}, [adminOrgProfile])

	useEffect(() => {
		if (manageAdminOrgUsersOutcome) {
			const updateWithNewOutcome = (manageAdminOrgUsersOutcome) => {
				const { updatedSuccessfully, updatedOrgSeats } = manageAdminOrgUsersOutcome || {};

				if (updatedSuccessfully === true && updatedOrgSeats >= 0) {

					setLocalState(prevState => ({
						...prevState,
						orgSeats: updatedOrgSeats
					}))
				}
			}
			updateWithNewOutcome(manageAdminOrgUsersOutcome)

		}
	}, [manageAdminOrgUsersOutcome])


	const {
		noOrgFound,
		isAdministrator,
		orgSeats,
		subscriptionReminder
	} = localState;



	const renderManageBilling = () => {
		if (!!subscriptionReminder) {
			return (
				<Box>
					<Flex justify='space-between' direction={['column', 'row', 'row', 'row']}>
						<Box className="user-profile-section__first-label"> Upgrade </Box>
					</Flex>
					<Divider />
					<Box mt='2em'>
						<DynamicAppBannerDisplay bannerType="subscription-nudge" isUndismissable isMobileView={isMobileView}/>
					</Box>
				</Box>
			)
		} else {
			// TODO: Improve this by checking against the availability of stripeCustomerId to ensure stripe session can be created
			return (
				<Box>
					<Flex justify={['center', 'space-between']} direction={['row', 'row', 'row', 'row']}>

						<Box className="user-profile-section__first-label" display={['none', 'none', 'block', 'block']}> Invoices & payment method </Box>
						<Box className="user-profile-section__first-label" display={['block', 'block', 'none', 'none']}> Invoices </Box>

						{!isMobileView &&
							<StripeCustomerPortalButton />
						}
					</Flex>


					<Divider />
					<Box mt='2em'>

						<Box>
							<Box mt='2em'>
								<Box >

									<Box color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={isMobileView && 'center'}>Status</Box>
									<Box mt='0.5em' lineHeight='1.375em' fontWeight='400' textAlign={isMobileView && 'center'}>Active</Box>
								</Box>

								<Box mt='2em' >

									<Box color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={isMobileView && 'center'}>Seats</Box>
									<Box mt='0.5em' lineHeight='1.375em' fontWeight='400' textAlign={isMobileView && 'center'}>{orgSeats ? orgSeats : '-'}</Box>
								</Box>

							</Box>
							{isMobileView &&
								<Flex justify='center' align='flex-start' mt='1.5em' w='100%' px='1em'>
									<StripeCustomerPortalButton w='100%' />

								</Flex>
							}


						</Box>

					</Box>
				</Box>
			)
		}
	}

	if (noOrgFound === false && isAdministrator) {
		return (
			<Flex w='100%' direction='column'>
				{!isMobileView && <>
					<Flex w='100%' justify='space-between' alignItems={['flex-start', 'center', 'center', 'center']}>
						<Box className="user-profile-section__first-label"> Billing details </Box>
						<LaunchdeckButton bg='brand.500' color='white' onClick={() => setShowEditOrgInfoModal(true)} label='Edit' />
					</Flex>
					<Divider />
				</>
				}
				<LaunchdeckModal
				maxW='35em'
					title='Edit billing details'
					handleCloseModal={() => setShowEditOrgInfoModal(false)}
					showModal={showEditOrgInfoModal}
				>
					<EditOrgBillingForm
						orgProfile={orgProfile}
						setOrgProfile={setOrgProfile}
						handleCloseModal={() => setShowEditOrgInfoModal(false)}
					/>
				</LaunchdeckModal>




				<OrgInfoDisplay mode='billing' />

				{isMobileView && <Flex mt='3em' w='100%' px='1em' >
					<LaunchdeckButton bg='brand.500' color='white' w='100%' onClick={() => setShowEditOrgInfoModal(true)} label='Edit billing' />
				</Flex>}

				<Box mt='5em'>
					{renderManageBilling()}
				</Box>

			</Flex>
		)
	}

	if (!noOrgFound) {
		return (
			<Flex w='100%' h='70rem' alignItems='center' justify='center' height='50%' my='3%'>
				<Spinner
					thickness="5px"
					speed="0.65s"
					emptyColor="gray.200"
					color="brand.500"
					boxSize="5em"
				/>
			</Flex>
		)
	} else return null;
}